// AdminHeader.jsx
import { React, useState, useEffect } from 'react';
import './header.css';
import { useLocation } from 'react-router-dom';
import { logout } from '../../../../Redux/actions';
import { ReactComponent as Notification } from '../../../assets/images/svgIcons/ic_bell.svg';
import { ReactComponent as Chat } from '../../../assets/images/svgIcons/ic_chat.svg';
import { ReactComponent as Setting } from '../../../assets/images/svgIcons/ic_setting.svg';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { FaRightFromBracket } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getUserId, getUserName } from '../../../../Redux/selecters';
import ApiService from '../../../services/apiService';

const AdminHeader = () => {
  const [headerText, setHeaderText] = useState('Dashboard');
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const userName = useSelector(getUserName);
  const userId = useSelector(getUserId);

  useEffect(() => {
    const menuRegex = /^\/admin\/menu\/[^\/]+\/[^\/]+$/;
    const updateRegex = /^\/admin\/master\/Update\/(.+)$/;
    const { pathname } = location;

    if (pathname === '/admin/menu') {
      setHeaderText(`${t('Menu')}`);
    } else if (pathname === '/admin/orders') {
      setHeaderText(`${t('Orders')}`);
    } else if (pathname.includes('/admin/order/')) {
      setHeaderText(`${t('Orders')}`);
    } else if (pathname === '/home') {
      setHeaderText(`${t('Dashboard')}`);
    } else if (pathname === '/admin/ordersDND') {
      setHeaderText(`${t('Drag_and_Drop')}`);
    } else if (pathname === '/admin/master/Create') {
      setHeaderText(`${t('Create')} ${t('Item')}`);
    } else if (pathname === '/admin/master/promotion') {
      setHeaderText(`${t('Promotion Master')}`);
    } else if (pathname === '/admin/master/ItemMaster/Create') {
      setHeaderText(`${t('Create')} ${t('Item')}`);
    } else if (pathname === '/admin/CustomerList') {
      setHeaderText(`${t('Customers')} ${t('List')}`);
    } else if (pathname === '/admin/AddCustomer') {
      setHeaderText(`${t('Add')} ${t('Customers')}`);
    } else if (pathname === '/admin/Company/Create') {
      setHeaderText(`${t('Company')}`);
    } else if (pathname === '/admin/Company/Branch/Create') {
      setHeaderText(`${t('Branches')}`);
    } else if (pathname === '/admin/Company') {
      setHeaderText(`${t('Company')}`);
    } else if (pathname === '/admin/employee') {
      setHeaderText(`${t('Employees')}`);
    } else if (pathname === '/admin/Addemployee') {
      setHeaderText(`${t('Employees')}`);
    } else if (pathname === '/admin/itemMaster/modifier') {
      setHeaderText(`${t('Modifiers')} ${t('Masters')}`);
    } else if (pathname === '/admin/itemMaster/addsOns') {
      setHeaderText(`${t('Addons')} ${t('Masters')}`);
    } else if (pathname === '/admin/itemMaster/Combos') {
      setHeaderText(`${t('Combo')} ${t('Masters')}`);
    } else if (pathname === '/admin/itemMaster/addCategory') {
      setHeaderText(`${t('Item')} ${t('Category')}`);
    } else if (pathname === '/admin/itemMaster/subCategory') {
      setHeaderText(`${t('Item')} ${t('Subcategory')}`);
    } else if (pathname === '/admin/master/Variants') {
      setHeaderText(`${t('Item')} ${t('Variants')}`);
    } else if (pathname === '/admin/itemMaster/UploadFile') {
      setHeaderText('CSV File Management');
    } else if (pathname === '/admin/posting') {
      setHeaderText('Posting');
    } else if (pathname === '/admin/master/CurrencyManagement') {
      setHeaderText(`${t('Currency')} ${t('Masters')}`);
    } else if (pathname === '/admin/Delivery/Create') {
      setHeaderText('Delivery Platforms');
    } else if (pathname === '/admin/master/TaxManagement') {
      setHeaderText(`${t('Tax')} ${t('Masters')}`);
    } else if (pathname === '/admin/master/bulkItemselse') {
      setHeaderText(`${t('Bulk')} ${t('Upload')}`);
    } else if (pathname === '/admin/master/Table') {
      setHeaderText(`${t('Table')} ${t('Masters')}`);
    } else if (pathname === '/admin/master/Discount') {
      setHeaderText(`${t('Discount')} ${t('Masters')}`);
    } else if (pathname === '/admin/Payment') {
      setHeaderText(`${t('Payments')}`);
    } else if (pathname === '/admin/master/Kitchen') {
      setHeaderText(`${t('Kitchen')} ${t('Masters')}`);
    } else if (menuRegex.test(pathname)) {
      setHeaderText(`${t('Item')} ${t('Masters')}`);
    } else if (updateRegex.test(pathname)) {
      setHeaderText(`${t('Update')} ${t('Item')}`);
    } else if (pathname === '/admin/Reports/home') {
      setHeaderText(`${t('Total_Sale_Report')}`);
    } else if (pathname === '/admin/Reports/SaleDetails') {
      setHeaderText(`${t('Sales')} ${t('Details')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/Order') {
      setHeaderText(`${t('Orders')} ${t('Details')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/OrderHistory') {
      setHeaderText(`${t('Orders')} ${t('History')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/TotalSale') {
      setHeaderText(`${t('Monthly')} ${t('Sales')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/Cash') {
      setHeaderText(`${t('Cash_In')} ${t('Cash_Out')}  ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/Table') {
      setHeaderText(`${t('Table')}  ${t('Reports')}`);
    } else if (pathname === '/admin/master/area') {
      setHeaderText(`${t('Table')} ${t('Area')}  ${t('Masters')}`);
    } else if (pathname === '/admin/master/paymentMethod') {
      setHeaderText(`${t('Payments')} ${t('Masters')}`);
    } else if (pathname === '/admin/itemMaster/CounterMaster') {
      setHeaderText(`${t('Counter')} ${t('Masters')}`);
    } else if (pathname === '/admin/itemMaster/Variants') {
      setHeaderText(`${t('Variants')} ${t('Masters')}`);
    } else if (pathname === '/admin/Setting/Profile') {
      setHeaderText(`${t('Setting')}`);
    } else if (pathname === '/admin/Setting/Notification') {
      setHeaderText(`${t('Setting')}`);
    } else if (pathname === '/admin/Setting/Currency') {
      setHeaderText(`${t('Setting')}`);
    } else if (pathname === '/admin/Setting/Tax') {
      setHeaderText(`${t('Setting')}`);
    } else if (pathname === '/admin/Setting/Theme') {
      setHeaderText(`${t('Setting')}`);
    } else if (pathname === '/admin/Reports/Dashboard') {
      setHeaderText(`${t('Reports')} ${t('Dashboard')}`);
    } else if (pathname === '/admin/Reports/XReport') {
      setHeaderText(`${t('X_Report')}`);
    } else if (pathname === '/admin/Reports/ZReport') {
      setHeaderText(`${t('Z_Report')}`);
    } else if (pathname === '/admin/Reports/CustomerOrders') {
      setHeaderText(`${t('Customers')} ${t('Orders')} ${t('Count')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/List') {
      setHeaderText(`${t('Reports')} ${t('List')}`);
    } else if (pathname === '/admin/Master/List') {
      setHeaderText(`${t('Masters')} ${t('List')}`);
    } else if (pathname === '/admin/Reports/ItemSale') {
      setHeaderText(`${t('Sales')} ${t('Detail')} `);
    } else if (pathname === '/admin/Reports/CategorySale') {
      setHeaderText(`${t('Category')} ${t('Sales')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/category') {
      setHeaderText(`${t('Sale')} ${t('Summary')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/cashier') {
      setHeaderText(`${t('Cashier')} ${t('Sales')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/PaymentMethod') {
      setHeaderText(`${t('Payments')} ${t('Type')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/SaleTax') {
      setHeaderText(`${t('Sales')} ${t('Tax')} ${t('Reports')}`);
    } else if (pathname === '/admin/master/terminal') {
      setHeaderText(`${t('Terminal')} ${t('Masters')}`);
    } else if (pathname === '/admin/master/marchaint') {
      setHeaderText(`${t('Merchaint')} ${t('Masters')}`);
    } else if (pathname === '/admin/master/QR') {
      setHeaderText(`${t('QR')} ${t('Masters')}`);
    } else if (pathname === '/admin/Reports/stores-sale') {
      setHeaderText(`${t('Store')} ${t('Sales')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/ProfitMargin') {
      setHeaderText(`${t('Profit')} ${t('Margin')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/BestWorstSales') {
      setHeaderText(`${t('Best')} & ${t('Least')} ${t(' Reports')}`);
    } else if (pathname === '/admin/Reports/FlashSummary') {
      setHeaderText(`${t('Flash')} ${t('Sale')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/GiftCardReport') {
      setHeaderText(`${t('Gift Card')} ${t('Details')}`);
    } else if (pathname === '/admin/Reports/SalesByHour') {
      setHeaderText(`${t('Sales')} ${t('By')} ${t('Hour')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/DailySalesSummary') {
      setHeaderText(`${t('Daily')} ${t('Sales')} ${t('Reports')}`);
    } else if (pathname === '/admin/master/bulkItems') {
      setHeaderText(`${t('Item')} ${t('Bulk_Upload')}`);
    } else if (pathname === '/admin/Reports/PurchaseTax') {
      setHeaderText(`Purchase ${t('Tax')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/ItemExpirySummary') {
      setHeaderText(`${t('Item')} ${t('Expiry')} ${t('Report')}`);
    } else if (pathname === '/admin/Reports/AllSaleReport') {
      setHeaderText(`${t('Sale')} ${t('Report')} ${t('Amount Wise')}`);
    } else if (pathname === '/admin/Reports/BrandSale') {
      setHeaderText(`${t('Brand')} ${t('Sale')} ${t('Report')}`);
    } else if (pathname === '/admin/Reports/StockCheck') {
      setHeaderText(`${t('Stock')} ${t('Report')}`);
    } else if (pathname === '/admin/Reports/PredictiveInventory') {
      setHeaderText(`${t('Predictive')} ${t('Inventory')} ${t('Report')}`);
    } else {
      setHeaderText(`${t('Dashboard')}`);
    }
  }, [location, t]);

  const handleOut = () => {
    dispatch(logout());
    localStorage.clear();
    window.location.href = 'https://app.pro360erp.com/';
  };

  // 🔹 THIS is where we decide if admin can go to cashier side
  // AdminHeader.jsx

  const handleSwitchtoCashier = async () => {
    try {
      if (!userId) {
        alert('User not found. Please login again.');
        return;
      }

      const apiService = new ApiService();
      const param = `?UserId=${userId}`;

      // 🔁 use GET_EMPLOYEE here instead of GET_BRANCH
      const res = await apiService.getApiParamater('GET_EMPLOYEE', param);

      // Depending on your API, adjust this if needed:
      // if GET_EMPLOYEE directly returns branches, this is fine.
      // If it returns employees with a branch nested, you’d map them here.
      const branches = res?.data?.result || [];

      if (!branches.length) {
        // ❌ No branches for this admin -> no cashier access
        localStorage.removeItem('HasCashierAccess');
        localStorage.removeItem('AdminBranches');
        localStorage.removeItem('BranchId');
        alert('You do not have cashier / branch access.');
        return;
      }

      // ✅ mark that this admin *has* cashier access
      localStorage.setItem('HasCashierAccess', 'true');

      // store branches list for CounterSelector
      localStorage.setItem('AdminBranches', JSON.stringify(branches));

      // Decide how to pick initial BranchId from GET_EMPLOYEE row
      // If your GET_EMPLOYEE row looks like the branch object you pasted (with id),
      // this is correct:
      const firstBranch = branches[0];
      const firstBranchId =
        firstBranch?.res_Branch_Id ?? firstBranch?.branchId ?? firstBranch?.BranchId ?? firstBranch?.branchNo ?? firstBranch?.branch?.id ?? null;

      if (firstBranchId != null) {
        localStorage.setItem('BranchId', String(firstBranchId));
      }

      // 🔀 open cashier counter selection (case-sensitive, matches AppRoutes)
      window.open('/cashier/counterselection', '_blank');
    } catch (err) {
      console.error('Failed to check cashier access (GET_EMPLOYEE):', err);
      alert('Unable to verify cashier access right now. Please try again.');
    }
  };

  return (
    <nav className="navbar-expand-lg mainBG">
      <div className="container-fluid">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse d-flex justify-content-between" id="navbarSupportedContent">
          <div className="dnon">
            <div className="Headtxt">{headerText}</div>
            <div className="headtxt2"></div>
          </div>
          <div className="d-flex gap-2 pad">
            <div className="gap-2 d-flex">
              <div className="addbrnchbtn d-flex gap-3" onClick={handleSwitchtoCashier}>
                <div className="center">PO {t('sales')}</div>
                <FaRightFromBracket className="center mt-2" />
              </div>
              <div className="iconBG">
                <Notification />
              </div>
              <div className="iconBG">
                <Chat />
              </div>
            </div>
            <div className="profilebox dropdown">
              {userName || 'Admin'}
              <div className="dropdown-content-stats pt-1">
                <Link to="/admin/Setting/Currency" className="p-2">
                  {t('setting')}
                </Link>
                <Link onClick={handleOut} className="p-2">
                  {t('Logout')}
                </Link>
              </div>
            </div>
            <div className="adminprofileimgbox boxicon">
              <Setting className="" size={25} />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(AdminHeader);
